
import React from 'react'
import { useRef } from "react";
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { useState, useEffect} from 'react'
import { DisplayAllTests } from '../aitest/DisplayAllTests'
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { ProgressIcon } from '../customicons/ProgressIcon';
import { Description } from '../aitest/Description'
import { BuyTestDialog } from '../purchasetest/BuyTestDialog'
import { DialogTestLanguage } from './DialogTestLanguage';
import { DialogTestSchool } from './DialogTestSchool'
import { PageTitle } from './PageTitle'
import { RadioButtonsSchoolYear } from './RadioButtonsSchoolYear'
import { Subtopics } from './Subtopics';
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import { ArrowForwardIconLightBlue } from '../customicons/ArrowForwardIconLightBlue';
import { QuestionIcon } from '../customicons/QuestionIcon';

import "./aitest.css"

export const CollegeTest = () => {

  const targetRef = useRef(null);

  const [tempchatNames, setTempChatNames] = useState([])

  const [showFacultyMenu, setShowFacultyMenu] = useState(false);

  const facultyOptions = ["Gradjevinarstvo", "Geodezija", "Geoinformatika"];     

  const {
    isMe,
    isMobile,
    changeTestLanguage,
    setTestLanguage,
    isPromotion,
  } = React.useContext(StatusContext);

  const {
    subtopics,
    chatcollegetestNames,
    
    deleteChat,
    displayCollegeChat,

    chatName,
    setChatName,
    isLoading,
    description,
    onChangeDescription,
    descriptionRef,
    handleDescriptionFocus,
    getTestLanguage,
    showalltests,

    setSchool,
    getSchool,
    setSchoolYear,
    getSchoolYear,
    getUniversity,
    saveCollegeIndex,
    selectedcourse,
    setShowSchoolYearCourses,
    universities,
    universityindex,
    setCollegeIndex,
    setUniversityIndex,
    getUniversityIndex,
    university,
    getCollegeIndex,
    setChatCollegeTestNames,
    setDescription,
    setSubtopics,
    setSelectedCourse,
    getFreeTests,
    testisbought,
    setTestIsBought,
    setShowQuestionsOnly,
   
  } = React.useContext(AITestContext);

  useEffect(() => {
    console.log("useEffect: CollegeTest")
    
    setTempChatNames([...chatcollegetestNames])
    setTestLanguage(getTestLanguage())
    setSchool(getSchool())
    setSchoolYear(getSchoolYear())
    setShowSchoolYearCourses(getSchoolYear())
    setCollegeIndex(getCollegeIndex())
    
  }, [chatcollegetestNames, setTestLanguage, getTestLanguage, 
      setSchool, getSchool, setSchoolYear, getSchoolYear, 
      setShowSchoolYearCourses, university, getUniversityIndex,
      setUniversityIndex, setCollegeIndex, getCollegeIndex,
     ]);


  const onClickFaculty = (college, index) => {
   
    console.log("onClickFaculty:", college, index)
  
    saveCollegeIndex(index)

    setSchool(college)
    setSchoolYear(college)
    setCollegeIndex(index)
    setChatCollegeTestNames([])
    setDescription()
    setSubtopics([])
    setChatName("")
    setSelectedCourse("")
    setTestIsBought(true)
    setShowQuestionsOnly(false)
  
  }

  const handleFacultyOptionSelect = (option) => {
    console.log("Option:", option)
    if (option === 'Gradjevinarstvo')
      onClickFaculty("Gradjevinski fakultet - Gradjevinarstvo",1);
    else if (option === 'Geodezija')
      onClickFaculty("Gradjevinski fakultet - Geodezija", 2);
    else if (option === 'Geoinformatika')
      onClickFaculty("Gradjevinski fakultet - Geoinformatika", 3);
    else
      console.log("Not able to find a college.")

  setShowFacultyMenu(false);
};

const isSelected = (index) => {
  const collegeindex = parseInt(getCollegeIndex(), 10);
  const parentindex = universities[universityindex].college[collegeindex].parentindex

  return parentindex === index
};

const isSelected_1 = (option) => {
    return 0
  }


  return (

    <div>

      <PageTitle title = {getUniversity()} />
      <br/>
      <Row>
          <Col className="aitestChooseColumn" style={{ width: "100%", paddingLeft:isMobile() ? '3%' : '10%',   paddingRight: isMobile() ? '3%' : '10%'}}>
          {
            <>
            {
             
            <>
            {
              !isMobile() ?
             <div className="pageButtonsContainer">
                <Row>
                   <Col className={ isSelected(0) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[0].collegename, 0)}}> 
                    <div>{universities[universityindex].college[0].collegename}</div>
                  </Col>
                  {
                    isMe() &&
                     <Col  className={isSelected(1) 
                        ? "facultyButtonSelected"
                        : "facultyButton"}
                        onClick={() => setShowFacultyMenu(true)}
                    >
                      <div>{universities[universityindex].college[1].collegename}</div>
                      <div style={{ fontSize: "12px" }}>(U pripremi...)</div>
                      
                    </Col>
                 
                  }

                    <Col className={ isSelected(4) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[4].collegename, 4)}}> 
                    <div>{universities[universityindex].college[4].collegename}</div>
                  </Col>

                  <Col className={ isSelected(5) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[5].collegename, 5)}}> 
                    <div>{universities[universityindex].college[5].collegename}</div>
                  </Col>
                  
                    <Col className={ isSelected(6) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[6].collegename, 6)}}> 
                    <div>{universities[universityindex].college[6].collegename}</div>
                    
                  </Col>
                    
           
                </Row>
              </div>
              :
               <div  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}>
               
                  <Row>
                  <Col className={ isSelected(0) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[0].collegename, 0)}}> 
                   <div>{universities[universityindex].college[0].collegename}</div>
                  </Col>
                </Row>
                {
                  isMe() &&
                  <Row>
                  
                    <Col  className={isSelected(1) 
                        ? "facultyButtonSelected"
                        : "facultyButton"}
                        onClick={() => setShowFacultyMenu(true)}
                    >
                      <div>{universities[universityindex].college[1].collegename}</div>
                      <div style={{ fontSize: "12px" }}>(U pripremi...)</div>
                      
                    </Col>
                    
                  </Row>
                }
                 <Row>
                  <Col className={ isSelected(4) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[4].collegename, 4)}}> 
                    <div>{universities[universityindex].college[4].collegename}</div>
                  </Col>
                </Row>
                <Row>
                  <Col className={ isSelected(5) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[5].collegename,5)}}> 
                    <div>{universities[universityindex].college[5].collegename}</div>
                  </Col>
                </Row>
                
                 
                  <Row>
                    <Col className={ isSelected(6) ? 'facultyButtonSelected' : 'facultyButton'} onClick={()=>{onClickFaculty(universities[universityindex].college[6].collegename, 6)}}> 
                      <div>{universities[universityindex].college[6].collegename}</div>
                      
                    </Col>
                  </Row>
                
        
            </div>
              }
              
              {
                <div className="pageButtonsContainer" >
                  {
                    !isPromotion() && getFreeTests() === 2 &&
                   <label style={{fontSize: '20px',color:'black'}}> {changeTestLanguage("aitest", "twofreetests")} </label>
                 }
                  {
                     !isPromotion() && getFreeTests() === 1 &&
                    <label style={{fontSize: '20px',color:'black'}}> {changeTestLanguage("aitest", "onefreetests")} </label>
                }
                    
                  <br/>
            
                    {
                      isPromotion() &&
                        <>
                        <div>
                          <label style={{color:'maroon', fontSize:'18px', fontWeight:'500'}}>{changeTestLanguage("aitest", "promotions")}</label>
                        
                        <br/>
                        <label style={{color:'maroon', fontSize:'16px', fontWeight:'500'}}>{changeTestLanguage("aitest", "promotionstext")}</label>
                       </div>
                       <br/>
                       <label>{changeTestLanguage("aitest", "afterpromotion")}</label>
                        
                        </>
                    }

                     <label style={{color:'maroon'}}>{changeTestLanguage("aitest", "textcenatestova")}</label>
                    <br/>
                    <br/>
                   
                </div>
              }

              {
              <div className="pageButtonsContainer">
                {
                
                  <div >
                    <Row>
                      <Col>
                        <RadioButtonsSchoolYear scrollref = {targetRef} />
                      </Col>
                    </Row>
                    </div>
                }
              </div>
              }
              </>
            }
           
           
            <br/>
            </>
          }

        </Col>
        </Row>

      
        <Row>
           <Col style={{ width: "100%", paddingLeft:isMobile() ? '3%' : '10%',   paddingRight: isMobile() ? '3%' : '10%'}}>
           
          {
            (showalltests) &&
            <>
            <div  ref={targetRef} style={{ textAlign: 'center' }}>
           
            <label className='selectedCourse'>{selectedcourse}</label>
           
            {
              !isPromotion() && testisbought === false &&
              <>
              <br/>
              <label className='testNotBought'>{changeTestLanguage('aitest', 'testnotbought')}</label>
              </>
            }
            </div>
           
                <div className="displayTestsContainer">
                  <div className="navbarNames">
                    {
                      Array.isArray(tempchatNames) &&
                      tempchatNames.map((chat, idx) => (

                        <React.Fragment key={chat.id}>
                          <DisplayAllTests key={chat.id}
                            chat={chat}
                            deleteHandler={deleteChat}
                            clickHandler={displayCollegeChat}
                            setTemplateName={setChatName}
                            handleFocus={handleDescriptionFocus}
                            seqid={idx + 1}
                            total={tempchatNames.length}
                          />
                           <hr className='aitestLineSeparator'></hr>
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>

            {
              subtopics.length > 0 &&
              <>
                <br/>
                <div ref={descriptionRef} className="pageButtonsContainer" style={{width:'100%'}}> 
                    <label style={{color:'black'}}>{changeTestLanguage('aitest', 'test')}</label>
                    <br/>
                    <label style={{ fontSize: isMobile() ? '16px' : '18px',fontWeight:'400',color:'black'}}> {chatName} </label>
                </div>
                <div  style={{ width: "100%", paddingLeft:isMobile() ? '0%' : '10%',   paddingRight: isMobile() ? '0%' : '10%'}}>
                <br/>
                <Description
                  title={changeTestLanguage('aitest', 'description')}
                  description={description}
                  disabled={true}
                  onChange={onChangeDescription} />

                <Subtopics />

                </div>
        
              </>

            }

          
              <div className="pageButtonsContainer" style={{width:'100%', fontSize:'12px'}}>
            
                <br/>
                <label><span className='disclaimer'>{changeTestLanguage('aitest', 'disclaimer')}</span><span>{changeTestLanguage('aitest', 'disclaimertext')}</span></label>
                <br/>
                <label><span>{changeTestLanguage('aitest', 'advicetext')}</span></label>
                <br/>
                <label>{changeTestLanguage('aitest', 'additionalcreditstex_1')}</label>
                
                <label ><QuestionIcon /></label>
                <label><ArrowForwardIconLightBlue /></label>
                <label style={{paddingLeft:'10px'}}>{changeTestLanguage('aitest', 'additionalcreditstex_2')}</label>
                
                <div style = {{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', width:'100%'}}>
                 <AvailableCredits />
                </div>
              </div>

            </>
              
            }

          </Col>
      </Row>
     
      <Modal
        show={showFacultyMenu}
        onHide={() => setShowFacultyMenu(false)}
        centered
        aria-labelledby="faculty-menu-title"
      >
      <Modal.Header closeButton>
        <Modal.Title id="faculty-menu-title">
          Izaberite smer
        </Modal.Title>
      </Modal.Header>

        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {facultyOptions.map((option) => (
        <Button
          key={option}
          type="button"
          variant={
            isSelected_1(option) ? "primary" : "outline-primary"
          }
          onClick={() => handleFacultyOptionSelect(option)}
        >
          {option}
        </Button>
      ))}
          </div>
        </Modal.Body>
      </Modal>


      <DialogTestLanguage />
      <DialogTestSchool />
      <BuyTestDialog />
      <ProgressIcon isLoading={isLoading} />

      
    </div>
  )
}
